import {ActivityService} from '@services/activity/activity.service';
import {useVideoPlayer, useVideoPlayerState} from '../../useVideoPlayer';
import {VideoControlsItem} from '../Item/VideoControlsItem';

import {Icon} from '@components/@icons';
export const VideoCCButton = () => {
    const {toggleCC} = useVideoPlayer();
    const textTrackIndex = useVideoPlayerState(s => s.textTrackIndex);
    const ccEnabled = useVideoPlayerState(s => s.ccEnabled);
    const metadata = useVideoPlayerState(s => s.metadata);

    const hasTextTracks = textTrackIndex !== -1;

    const handletoggleCC = () => {
        ActivityService.logElementClick({
            resource_id: 'btn_cc_toggle',
            subtitle_state: ccEnabled ? 'off' : 'on',
            ...(metadata &&
                'video_id' in metadata && {
                    video_id: metadata.video_id,
                }),
        });

        toggleCC();
    };

    if (!hasTextTracks) {
        return null;
    }

    return (
        <VideoControlsItem onClick={handletoggleCC}>
            {ccEnabled ? (
                <Icon name="caption-on" />
            ) : (
                <Icon name="caption-off" />
            )}
        </VideoControlsItem>
    );
};
